<template>
    <div>
        <div class="tw-flex tw-items-center tw-gap-4">
            <h1 class="tw-border-s-2 tw-border-solid tw-border-primary-500 tw-ps-2 tw-text-base">{{ $t('common.offers')
                }}</h1>
            <CreateOfferPopup @created="onCreated" />
        </div>

        <div v-if="offers.length == 0"
            class="tw-p-5 tw-text-center tw-bg-gray-50 tw-rounded tw-border tw-border-solid tw-border-gray-200 tw-mt-4">
            <p>{{ $t('messages.table-no-results') }}</p>
        </div>

        <template v-else>
            <div
                class="tw-mt-4 tw-rounded tw-border tw-border-gray-200 tw-bg-white tw-shadow-sm tw-overflow-hidden">
                <div class="tw-divide-y tw-divide-gray-100">
                    <div v-for="o in offers" :key="o.id"
                        class="tw-flex tw-items-center tw-justify-between tw-px-4 tw-py-2 hover:tw-bg-gray-50 transition">
                        <!-- Offer Details -->
                        <div class="tw-flex tw-items-center tw-gap-4">
                            <div class="tw-flex tw-flex-col tw-min-w-[50px]">
                                <p class="tw-text-[10px] tw-text-gray-500">{{ $t('fields.quantity') }}</p>
                                <p class="tw-text-sm tw-font-semibold">{{ o.quantity }}</p>
                            </div>

                            <div class="tw-flex tw-flex-col tw-min-w-[60px]">
                                <p class="tw-text-[10px] tw-text-gray-500">{{ $t('fields.price') }}</p>
                                <div class="tw-flex tw-items-end tw-gap-1">
                                    <p class="tw-text-sm  tw-font-semibold">{{ o.price }}</p>
                                    <span class="tw-text-xs tw-text-gray-500">{{ CURRENCY }}</span>
                                </div>
                            </div>

                            <div class="tw-flex tw-flex-col tw-min-w-[50px]">
                                <p class="tw-text-[10px] tw-text-gray-500">{{ $t('fields.note') }}</p>
                                <p class="tw-text-sm tw-truncate">{{ o.note }}</p>
                            </div>
                        </div>

                        <!-- Action Buttons -->
                        <div class="tw-flex tw-items-center tw-gap-2">
                            <update-offer-popup :offer="o" @updated="onUpdated" />
                            <a-button @click="deleteOffer(o.id)" intent="danger" class="tw-text-sm tw-px-3 tw-py-1 !tw-min-h-[20px]">
                                {{ $t('buttons.delete') }}
                            </a-button>
                        </div>
                    </div>
                </div>
            </div>
        </template>


    </div>
</template>

<script setup>
import { CURRENCY } from '@/config/app';
import CreateOfferPopup from './CreateOfferPopup.vue';
import  UpdateOfferPopup from './UpdateOfferPopup.vue';
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
    offers: {
        type: Array,
        default: () => []
    }
});

const emit = defineEmits(['update:offers']);

const onCreated = (offer) => {
    // Handle the created event here
    console.log('Offer created!');
    const updatedOffers = [...props.offers, offer];
    emit('update:offers', updatedOffers);
};

const onUpdated = (offer) => {
    const updatedOffers = [...props.offers];
    const index = updatedOffers.findIndex(o => o.id === offer.id);
    if (index !== -1) {
        updatedOffers[index] = offer;
        emit('update:offers', updatedOffers);
    }
};

const deleteOffer = (id) => {
    console.log('Deleting offer with ID:', id);
    const stringId = String(id);
    const updatedOffers = props.offers.filter(offer => String(offer.id) !== stringId);
    console.log('Offers after deletion:', updatedOffers);
    emit('update:offers', [...updatedOffers]);
    
    // Force update if needed
    setTimeout(() => {
        if (props.offers.some(o => String(o.id) === stringId)) {
            console.log('Offer still exists after deletion, forcing update');
            const forcedUpdate = props.offers.filter(o => String(o.id) !== stringId);
            emit('update:offers', [...forcedUpdate]);
        }
    }, 50);
};

</script>

<style></style>